import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function MagicSparkle({ color = colors.gray['700'], ...props }: Props) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7973 5.30006C2.95323 5.00971 3.25612 4.82856 3.58569 4.82856C3.91526 4.82856 4.21816 5.00971 4.37409 5.30006L5.06941 6.5726C5.15179 6.72388 5.27608 6.84817 5.42736 6.93055L6.69989 7.62588C6.99024 7.78181 7.17139 8.08471 7.17139 8.41428C7.17139 8.74385 6.99024 9.04675 6.69989 9.20268L5.42736 9.89801C5.27608 9.98039 5.15179 10.1047 5.06941 10.256L4.37409 11.5285C4.21816 11.8189 3.91526 12 3.58569 12C3.25612 12 2.95323 11.8189 2.7973 11.5285L2.10198 10.256C2.0196 10.1047 1.89531 9.98039 1.74402 9.89801L0.471499 9.20268C0.181148 9.04675 0 8.74385 0 8.41428C0 8.08471 0.181148 7.78181 0.471499 7.62588L1.74402 6.93055C1.89531 6.84817 2.0196 6.72388 2.10198 6.5726L2.7973 5.30006Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.72175 0.351086C8.83985 0.134654 9.06672 0 9.31327 0C9.55982 0 9.78669 0.134654 9.90479 0.351086L10.4265 1.30504C10.4883 1.4185 10.5815 1.51172 10.695 1.57351L11.6489 2.09523C11.8653 2.21332 12 2.44019 12 2.68675C12 2.9333 11.8653 3.16017 11.6489 3.27827L10.695 3.79999C10.5815 3.86178 10.4883 3.955 10.4265 4.06846L9.90479 5.02241C9.78669 5.23884 9.55982 5.3735 9.31327 5.3735C9.06672 5.3735 8.83985 5.23884 8.72175 5.02241L8.20004 4.06846C8.13825 3.955 8.04503 3.86178 7.93157 3.79999L6.97763 3.27827C6.7612 3.16017 6.62654 2.9333 6.62654 2.68675C6.62654 2.44019 6.7612 2.21332 6.97763 2.09523L7.93157 1.57351C8.04503 1.51172 8.13825 1.4185 8.20004 1.30504L8.72175 0.351086Z"
        fill={color}
      />
    </svg>
  );
}
